export default __webpack_public_path__ + "static/media/19682.3f82a940.png";